export class ioParameter{
  parameterId: number;
  parameterName: string;
  parameterDefaultValue: unknown;
  parameterDataType: string;
  parameterUom: string;
  captionName: string;
  uomType: string;
  componentName: string;

  constructor() {
    this.parameterId = 0;
    this.parameterName = '';
    this.parameterDefaultValue = null;
    this.parameterDataType = '';
    this.parameterUom = '';
    this.captionName = '';
    this.uomType = '';
    this.componentName = '';
  }
}
